import Model from '@/lib/data/Model';
import Currency from './Currency';
import Underwriter from './Underwriter';

class ServiceAgreement extends Model {
    static idProperty = 'id';

    fields = [
        { name: 'id' },
        { name: 'agreement_name' },
        { name: 'start_date' },
        { name: 'end_date' },
        { name: 'due_date' },
        { name: 'status', type: 'string', defaultValue: 'Draft' },
        { name: 'record_state', type: 'int', defaultValue: 1 },
        { name: 'customer_id' },
        { name: 'invoice_currency_id' },
        {
            name: 'invoice_currency',
            mapping: 'invoice_currency_id',
            association: {
                type: 'one',
                model: Currency,
            },
        },
        { name: 'underwriter_id' },
        {
            name: 'underwriter',
            mapping: 'underwriter_id',
            association: {
                type: 'one',
                model: Underwriter,
            },
        },
    ];

    /**
     * Create the User object
     *
     * @param {Object} data - Seed data for this object.
     */
    constructor(data) {
        super(data);
        this.init();
    }

    api = [
        {
            name: 'create',
            method: 'POST',
            url: '/serviceagreement/save',
            params: [
                'id',
                'agreement_name',
                'start_date',
                'end_date',
                'due_date',
                'status',
                'underwriter_id',
                'invoice_currency_id',
                'customer_id',
            ],
        },
        {
            name: 'update',
            method: 'POST',
            url: '/serviceagreement/save',
            params: [
                'id',
                'agreement_name',
                'start_date',
                'end_date',
                'due_date',
                'status',
                'underwriter_id',
                'invoice_currency_id',
            ],
        },
        {
            name: 'setAddresses',
            method: 'POST',
            url: '/serviceagreement/address/save',
            params: ['id', 'addresses'],
        },
        {
            name: 'delete',
            url: '/serviceagreement/delete',
            params: ['id'],
        },
    ];
}

export default ServiceAgreement;
